// extracted by mini-css-extract-plugin
export default {"root":"LayoutTwoColumn_root__IBvuW","leftColumn":"LayoutTwoColumn_leftColumn__wjCgI","rightColumn":"LayoutTwoColumn_rightColumn__rwxru"};